const acl = {
  tabUsers: 'उपयोगकर्ता',
  tabPermissions: 'भूमिका अनुमतियाँ',
  selectRoleToEdit: 'अनुमतियाँ संपादित करने के लिए भूमिका चुनें',
  featuresEnabled: 'सुविधाएँ सक्षम',
  savePermissions: 'अनुमतियाँ सहेजें',
  rolePermissionHint: '{{role}} के लिए पहुंच अनुमतियाँ कॉन्फ़िगर करना। सुविधाओं और उनके अनुमति स्तरों को सक्षम या अक्षम करें।',
  unsavedChanges: 'आपके पास सहेजे न गए परिवर्तन हैं।',
  grantAll: 'सभी अनुमतियाँ दें',
  removeAll: 'सभी अनुमतियाँ हटाएँ',
  permissionsSaved: 'अनुमतियाँ सफलतापूर्वक सहेजी गईं।',
  permView: 'देखें',
  permCreate: 'बनाएँ',
  permEdit: 'संपादित',
  permDelete: 'हटाएँ',
  permManage: 'प्रबंधित',
  noAccess: 'कोई पहुंच नहीं',
};

export default acl;